import type React from "react";
import { useTranslation } from "react-i18next";

import { type NoteVariant, StyledNote } from "./Note.styled";

export interface NoteProps {
  children: React.ReactNode;
  className?: string;
  dataCy?: string;
  variant?: NoteVariant;
}

export const Note: React.FC<NoteProps> = ({ className, children, dataCy, variant = "info" }) => {
  const { t } = useTranslation("common");

  const notePrefix =
    variant === "info" ? t("common:note.label.info") : t("common:note.label.default");

  return (
    <StyledNote $variant={variant} className={className} data-cy={dataCy}>
      <b>{notePrefix}:</b> {children}
    </StyledNote>
  );
};
